import { connect } from 'react-redux';
import ProductList from './productList';
import {
  fetchProductDetails,
  updateInWishlistProducts,
  sizeDeselected,
  sizeSelected,
  addProductToWishlistOnPlp,
  fetchProductsOnInfiniteScroll,
  updateDisplayedItems,
  fetchAdditionalProducts,
  fetchAllProducts,
} from './productListActions';
import { CLEAN_REFERRER_PRODUCT_ID } from './productListConstants';

const mapStateToProps = ({ products, isFetching, isGridView, showLoader, referrerProductId }) => ({
  products: products.items,
  error: products.error,
  numberOfProducts: products.totalItems,
  isFetching,
  isGridView,
  showLoader,
  referrerProductId,
});

const mapDispatchToProps = dispatch => ({
  onInfiniteScrollIntersection() {
    dispatch(fetchProductsOnInfiniteScroll());
  },
  updateProductDetails(productUrl, productId, productType) {
    dispatch(fetchProductDetails(productUrl, productId, productType));
  },
  onSizeSelected(sizeItem, productId) {
    dispatch(sizeSelected(sizeItem, productId));
  },
  onSizeDeselected(sizeItem, productId) {
    dispatch(sizeDeselected(sizeItem, productId));
  },
  onAddToWishlist(product, updateScreen) {
    dispatch(addProductToWishlistOnPlp(product, updateScreen));
  },
  cleanReferrerProductId() {
    dispatch({ type: CLEAN_REFERRER_PRODUCT_ID });
  },
  updateInWishlistProducts(response) {
    dispatch(updateInWishlistProducts(response));
  },

  updateDisplayedItems(displayedItems) {
    dispatch(updateDisplayedItems(displayedItems));
  },
  fetchAdditionalProducts() {
    dispatch(fetchAdditionalProducts());
  },
  fetchAllProducts() {
    dispatch(fetchAllProducts());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
